import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const LivingIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M7.99714 23.5435V50.6074H22.6594V37.4663H34.3692V50.6074H49.0441V23.5435L28.5269 11.5696L7.99714 23.5435Z" stroke={props.htmlColor || "black"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.66211 20.8164L28.5274 7.48022L39.9531 14.1483L51.3788 20.8164" stroke={props.htmlColor || "#FFCB06"} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  );
};

export default LivingIcon;
